import { render, staticRenderFns } from "./data-guide.vue?vue&type=template&id=08876c2a"
import script from "./data-guide.vue?vue&type=script&lang=ts"
export * from "./data-guide.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports